import { HealthLocationList } from '@/components/health/HealthLocationList';
import { useTourAttractions } from '@/hooks/useTourAttractionOrder';
import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

/**
 * Health > Location for a tour: lists every attraction on this tour whose
 * coordinates haven't been externally verified, with a one-click verify
 * flow per row.
 */
export function TourHealthLocationTab() {
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();

  const { data, isLoading } = useTourAttractions(id ?? null);

  if (!id) return null;

  return (
    <HealthLocationList
      attractions={data?.data}
      isLoading={isLoading}
      onAttractionUpdated={() => {
        // Refresh the tour attractions and the underlying attraction
        // detail caches so the row drops out of the list once the user
        // has saved a verified location.
        queryClient.invalidateQueries({ queryKey: ['TourAttractionOrder', id] });
        queryClient.invalidateQueries({ queryKey: ['Attraction'] });
      }}
    />
  );
}
